// ── EXIMNEX Technologies — site configuration ──────────────────────────
// Replace the placeholder below with the real WhatsApp business number:
// country code + number, digits only (e.g. "6591234567" for Singapore).
export const WHATSAPP_NUMBER = "919511267655";

export const WHATSAPP_MESSAGE =
  "Hello EXIMNEX Technologies Team, I would like to enquire about your services.";

// Business location shown in the footer — editable placeholder pending
// verification of the registered operating location.
export const BUSINESS_LOCATION = "Singapore";

export const NAV_LINKS = [
  { id: "home", label: "Home", href: "#home" },
  { id: "about", label: "About Us", href: "#about" },
  { id: "expertise", label: "Our Expertise", href: "#expertise" },
  { id: "contact", label: "Contact", href: "#contact" },
];

export const waLink = (message = WHATSAPP_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
